// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"223":"58476eb6","924":"abeb0e82"}[chunkId] + ".css";
};